import { useMutation } from '@apollo/client';
import { REVOKE_USER_SESSION, useApolloWrapperContext } from '@bessemercws/graphql';
import { useClientContext } from '@bessemercws/providers';
import { useNavigate } from 'react-router-dom';

export const useLogout = () => {
  const { client } = useApolloWrapperContext();
  const navigate = useNavigate();
  const { setIdToken, userId } = useClientContext();

  // Setup the mutation
  const [revokeUserSession] = useMutation(REVOKE_USER_SESSION);

  const logoutCallback = () => {
    setIdToken(undefined);

    // Call revokeUserSession mutation
    if (userId) {
      revokeUserSession({
        variables: {
          input: {
            userId,
          },
        },
      }).catch((error) => {
        console.error('Error revoking user session:', error);
      });
    }

    client.clearStore();
    navigate('/login');
  };

  return {
    logoutCallback,
  };
};
